module.exports = __webpack_public_path__ + "img/img38.deb8fd5d.png";